module.exports = __webpack_public_path__ + "static/media/previewlifestyle2-large.ae11d241.jpg";